import { useTranslation } from 'react-i18next';
import {
  DoorOpen,
  HandCoins,
  HeartHandshake,
  Users,
  type LucideIcon,
} from 'lucide-react';

import { LandingReveal } from './landing-shared';

const STORY_BEATS: ReadonlyArray<{
  key: 'welcome' | 'together' | 'care' | 'giving';
  icon: LucideIcon;
}> = [
  { key: 'welcome', icon: DoorOpen },
  { key: 'together', icon: Users },
  { key: 'care', icon: HeartHandshake },
  { key: 'giving', icon: HandCoins },
];

export const LandingStorySection = () => {
  const { t } = useTranslation('landing');

  return (
    <section
      id="story"
      className="landing-section-separator scroll-mt-20 py-16 sm:py-20 lg:py-24"
      aria-labelledby="story-heading"
    >
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <LandingReveal className="mx-auto max-w-2xl text-center">
          <p className="text-caption font-semibold uppercase tracking-[0.2em] text-on-brand/75">
            {t('story.eyebrow')}
          </p>
          <h2
            id="story-heading"
            className="landing-display mt-3 text-balance text-[1.75rem] font-semibold tracking-tight text-on-brand sm:text-[2rem]"
          >
            {t('story.title')}
          </h2>
          <p className="mt-3 text-pretty text-body leading-relaxed text-on-brand/90 sm:text-card-title">
            {t('story.subtitle')}
          </p>
        </LandingReveal>

        <ul className="mt-12 grid gap-4 sm:grid-cols-2 sm:gap-6 lg:gap-8">
          {STORY_BEATS.map(({ key, icon: Icon }, index) => (
            <LandingReveal key={key} as="li" delayMs={index * 60}>
              <article className="landing-story-card flex h-full flex-col rounded-2xl border border-white/20 bg-white/8 p-6">
                <span
                  className="landing-feature-icon landing-feature-icon-on-brand mb-4 w-fit"
                  aria-hidden
                >
                  <Icon className="size-5 stroke-[1.75]" />
                </span>
                <h3 className="text-card-title font-semibold tracking-tight text-on-brand">
                  {t(`story.beats.${key}.title`)}
                </h3>
                <p className="mt-2 flex-1 text-pretty text-body-sm leading-relaxed text-on-brand/90">
                  {t(`story.beats.${key}.body`)}
                </p>
              </article>
            </LandingReveal>
          ))}
        </ul>
      </div>
    </section>
  );
};
